import * as React from 'react'

import PropertiesPanel from '~/client/src/desktop/views/ProjectSetUp/components/AppsSitemap/components/PropertiesPanel/PropertiesPanel'
import MapViewSetUpStore, {
  SetUpSteps,
} from '~/client/src/desktop/views/ProjectSetUp/components/AppsSitemap/MapViewSetUp.store'
import { IResourceEditSection } from '~/client/src/shared/components/ResourceViewEdit/ResourceEditSections'
import Localization from '~/client/src/shared/localization/LocalizationManager'
import IGeoPosition from '~/client/src/shared/models/IGeoPosition'

import ProjectSetUpPageStore from '../../views/ProjectSetUp/ProjectSetUpPage.store'

interface IArgs {
  store: MapViewSetUpStore
  projectSetUpPageStore: ProjectSetUpPageStore
  viewport: IGeoPosition
  saveAlignment: () => void
  exitRubber: () => void
}

/**
 * The "Map Properties" section for a resource card rendered on the Maps view.
 * Resource-level (not equipment-specific): any location/resource whose map
 * object is the store's `selectedMapViewItem` can add this section. Reuses the
 * existing PropertiesPanel in `embedded` mode (no own name/save/scroll chrome).
 */
export function buildMapPropertiesSection({
  store,
  projectSetUpPageStore,
  viewport,
  saveAlignment,
  exitRubber,
}: IArgs): IResourceEditSection {
  return {
    id: 'map',
    label: Localization.translator.mapProperties,
    requiresSavedRecord: true,
    content: (
      <PropertiesPanel
        embedded
        store={store}
        step={SetUpSteps.alignPlan}
        saveAlignment={saveAlignment}
        exitRubber={exitRubber}
        viewport={viewport}
        projectSetUpPageStore={projectSetUpPageStore}
      />
    ),
  }
}
